/**
 * The designed absence of a read the running platform does not publish yet — an information
 * line, not an error (ADR 6004, ADR 0015's fifth state).
 *
 * Two chapters wrote this line independently (`inseason/NotPublishedNote`,
 * `strategic/RouteAbsentNote`); both now draw it from here, so that inside a page that draws one
 * strip (`docs/adr/9033`) the sentence is said there, once, as a `not-published` entry, and the
 * panel draws nothing of its own. Outside one it is the line it always was.
 */

import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

import { usePageStatusEntry } from './page-status';

export function NotPublishedLine({ bodyKey }: { readonly bodyKey: string }): React.JSX.Element | null {
  const { t } = useTranslation();
  const registered = usePageStatusEntry({ kind: 'not-published', message: { key: bodyKey } });
  if (registered) return null;
  return (
    <p className="text-caption text-ink-secondary flex items-start gap-2" data-not-published="">
      <Info size={14} aria-hidden className="shrink-0" style={{ marginBlockStart: 2 }} />
      <span>{t(bodyKey)}</span>
    </p>
  );
}
